<template>
    <div >



        <div class="container-fluid">
            <div class="container-width">

                <div class="row without_sliders no-gutters">
                    <div id="aside">
                        <teaser3 style-class="col-lg-12 col-md-12 col-sm-12 px-0" :teaser="getTeaser(1)" :position="1"></teaser3>
                        <teaser3 style-class="col-lg-12 col-md-12 col-sm-12 px-0" :teaser="getTeaser(2)" :position="2"></teaser3>
                    </div>
                    
                    
                    
                    
                    <div class="col-lg-8 col-md-8 col-sm-12 pl-0 pr-0 d-flex preview-card" itemscope itemtype="https://schema.org/NewsArticle">
                        <a href="#" @click.prevent="onView" class="read-more-9apuap" :style="style" itemprop="url">
                            <h6 class="read-more-9apuap__headline" itemprop="name">{{title}}</h6>
                            <div class="read-more-9apuap__image-block">
                                <img  :src="image"  ref="img" crossorigin=""  class="card-img"  itemprop="image">
                            </div>
                        </a>
                    </div>
                    
                    
                    
                    
                    
                    
<!--                     <div class="col-lg-8 col-md-8 col-sm-12 pl-0 pr-0 d-flex preview-card" itemscope itemtype="https://schema.org/NewsArticle">
                        <a href="#" @click.prevent="onView" class="item item-sec-row" :style="style" itemprop="url">


                            <div class="card_col_1">
                                <img  :src="image"  ref="img" crossorigin=""  class="card-img"  itemprop="image">
                            </div>
                            <div class="card-img-out">
                                <h5 class="card-title zip" itemprop="name">{{title}}</h5>

                                <div class="item__gradient" :style="gradientStyle"></div>
                            </div>

                        </a>
                    </div> -->
                    <!--<teaser2 style-class="col-lg-8 col-md-8 col-sm-12 pl-0 pr-0 pt-2 row-flex" :teaser="getTeaser()"></teaser2>-->
                    <teaser4 v-if="isTable() || teasers.length >= 3" style-class="col-lg-4  col-md-4 col-sm-12 pl-0 pr-0 d-flex teasers teaser4 ghffd"  :teaser="getTeaser(0)" :position="3"></teaser4>
                    <teaser4 v-if="!isTable()" style-class="col-lg-4  col-md-4 col-sm-12 pl-0 pr-0 d-flex teasers teaser4 ghffd"  :teaser="getTeaser(3)" :position="3"></teaser4>
                    <teaser4 v-if="!isTable()" style-class="col-lg-4  col-md-4 col-sm-12 pl-0 pr-0 d-flex teasers teaser4 ghffd"  :teaser="getTeaser(4)" :position="3"></teaser4>
                    <teaser4 v-if="!isTable()" style-class="col-lg-4  col-md-4 col-sm-12 pl-0 pr-0 d-flex teasers teaser4 ghffd"  :teaser="getTeaser(5)" :position="3"></teaser4>
                </div>
              
                
                 <div class="no-gutters row without_sliders" v-if="isTable()">
                    <teaser4  style-class="col-lg-4 col-md-4 col-sm-12 pl-0 pr-0 d-flex teasers teaser4" :teaser="getTeaser(3)" :position="4"></teaser4>
                    <teaser4 style-class="col-lg-4 col-md-4 col-sm-12 pl-0 pr-0 d-flex teasers teaser4" :teaser="getTeaser(4)" :position="5"></teaser4>
                    <teaser4 style-class="col-lg-4 col-md-4 col-sm-12 pl-0 pr-0 d-flex teasers teaser4" :teaser="getTeaser(5)" :position="6"></teaser4>
                </div>

                <div class="no-gutters row without_sliders" v-if="isTable()">
                    <teaser4  style-class="col-lg-4 col-md-4 col-sm-12 pl-0 pr-0 d-flex teasers teaser4" :teaser="getTeaser(6)" :position="7"></teaser4>
                    <teaser4 style-class="col-lg-4 col-md-4 col-sm-12 pl-0 pr-0 d-flex teasers teaser4" :teaser="getTeaser(7)" :position="8"></teaser4>
                    <teaser4 style-class="col-lg-4 col-md-4 col-sm-12 pl-0 pr-0 d-flex teasers teaser4" :teaser="getTeaser(8)" :position="9"></teaser4>
                </div>

                <!--<div class="no-gutters row without_sliders" v-if="!isTable()">-->
                    <!--<teaser  style-class="col-lg-4 col-md-4 col-sm-12 pl-0 pr-0 d-flex teasers" :teaser="getTeaser()" :position="2"></teaser>-->
                    <!--<teaser style-class="col-lg-4 col-md-4 col-sm-12 pl-0 pr-0 d-flex teasers" :teaser="getTeaser()" :position="3"></teaser>-->
                <!--</div>-->

                <!--<div class="no-gutters row without_sliders">-->

                    <!--<teaser style-class="col-lg-4  col-md-4 col-sm-12 pl-0 pr-0 d-flex "  :teaser="getTeaser()"></teaser>-->
                    <!--<teaser2 style-class="col-lg-8 col-md-8 col-sm-12 pl-0 pr-0 d-flex" :teaser="getTeaser()"></teaser2>-->
                <!--</div>-->
                <!--<teaser-group style-class-teaser="col-lg-4 col-md-4 col-sm-12 pl-0 pr-0 d-flex "-->
                              <!--style-class-group="no-gutters row without_sliders"-->
                              <!--:teasers="getTeasers(3)" ></teaser-group>-->

                <infinite :offset="teaserOffset" v-if="teaserOffset > 0"></infinite>



            </div>
            <pixel></pixel>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    // import teaser from '@/components/teaser.vue'
    import teaserGroup from '@/components/teaser-group.vue'
    import infinite from '@/components/infinite-preview2.vue'
    import pixel from '../components/pixel'
    import FastAverageColor from 'fast-average-color';

    import Teaser from '../components/teaser'
    import Teaser2 from '../components/teaser2'
    import Teaser3 from '../components/teaser3'
    import Teaser4 from '../components/teaser4'
    import TeaserMiniLoadingEx from '../components/teaser-mini-loading'


    export default {

        data(){
            return {
                image : '',
                title : '',
                text : '',
                rubric_id : 0,
                teasers:[],
                teaserOffset:0,
                news:{},

                gradientStyle:{},
                style:{},
                size: 50,
                scrolling:0,
                teasersLoaded:0,
                newsLoaded:0,
            };
        },
        components: {
            // teaser,
            teaserGroup,
            infinite,
            pixel,
            Teaser,
            Teaser2,
            Teaser3,
            Teaser4,
            TeaserMiniLoadingEx,

        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll, { once: true });
            
            let vue = this; 

        
            
            let img = this.$refs.img;
            img.crossorigin = '';
            
//             img.addEventListener('load', function()
//             {
//                 let fac = new FastAverageColor();
//                 let height = this.naturalHeight;

//                 let color = fac.getColor(this, {height: vue.size});

//                 var colorEnd = [].concat(color.value.slice(0, 3), 0).join(',');
//                 vue.style = {
//                     background: color.rgb,
//                     color:      color.isDark ? 'white' : 'black',
//                 };

//                 vue.gradientStyle  = {background: 'radial-gradient(123% 500% at 92%, ' +
//                         'rgba(' + colorEnd + ') 39%, ' + color.rgba + ' 73%)'};
//             }, false)


            this.Helper.getArticle(this.$route.query.utm_content, this.$route.query)
                .onSuccess((response)=>{
                    this.title = response.data.title;
                    this.image = response.data.image_rectangle;
                    this.text = response.data.text;
                    this.rubric_id = response.data.rubric_id;
                    this.news = response.data;

                })
                .onFail((error)=>{
                    console.log(error)
                });

            let amount = (this.isTable()) ? 9 : 6;
            //два первых тизера с качестовом 2
            this.Helper.getTeasers(this, 1, 0, 1,0,{quality:2},7)
                .onSuccess((response1)=>{
                    
                
                    //два тиезра без видео 
                    this.Helper.getTeasers(
                        this, 
                        2, 
                        1, 
                        1,
                        0,
                        {quality:2}, 7
//                         7, true, false
                    )
                    .onSuccess((response2)=>{
                        //остальные тизеры с качестовом 1
                        this.Helper.getTeasers(
                            this, 
                            amount -3, 
                            3, 
                            1,
                            0,
                            {quality:1},
                            7
                        )
                        .onSuccess((response3)=>{
                            this.teasers = response1.data.concat(response2.data, response3.data);

                            this.teaserOffset = response1.data.length + response2.data.length + response3.data.length;
                        })
                        .onFail((error)=>{
                            console.log(error)
                        })
                        })
                        .onFail((error)=>{
                            console.log(error)
                        })
                
                
                
                   
//                     this.teasers = response.data;
//                     this.teaserOffset = response.data.length;
                })
                .onFail((error)=>{
                    console.log(error)
                })
        },
        methods: {
            getTeasers (amount) {
                return this.Helper.getManyTeaser(this.teasers, amount);
            },

            getTeaser (index) {
                
                if (index === undefined) return this.Helper.getOneTeaser(this.teasers);
                if (!this.teasers[index]) return {};
                return this.teasers[index];
                
            },

            onView() {
                ym(94590406,'reachGoal','read_more_preview');
                this.Helper.newsPreviewClick(this, this.news);
            },
            // isPad(){
            //     return window.innerWidth >= 768;
            // }
            handleScroll() {
              ym(94590406, 'reachGoal', 'scroll');
              window.removeEventListener('scroll', this.handleScroll);
            }

        },
          
        beforeDestroy() {
    		window.removeEventListener('scroll', this.handleScroll);
  		}
    }
</script>


<style scoped>

</style>